import React from 'react';
// import ReactDOM from 'react-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import './transition.scss';

const childFactoryCreator = (props) => child => React.cloneElement(child, props),

    /**
     * Handle the entered callback.
     * When the animation finishes, scroll to the top and
     * adjust the min-height of the root element.
     * el is passed as a ref from react-transition-group
     * @param {HTMLElement} el
     */
    handleEntered = (el) => {
        const appEl = document.getElementById('heatingtool-app'),
            height = el.getBoundingClientRect().height;

        if (!height || !appEl) {
            return;
        }

        setTimeout(() => {
            appEl.style.minHeight = `${height}px`;
        }, 300);

        appEl.focus();
    },

    handleEntering = (el) => {
        const appEl = document.getElementById('heatingtool-app');

        if (!appEl) {
            return;
        }

        window.scrollTo({
            top: appEl.offsetTop,
            left: 0,
            // behavior: 'smooth'
            behavior: 'auto'
        });
    };

export default ({ transition = 'forward', duration = 1000, pageKey, children }) => {
    const HTTransition = transition === 'back' ? 'ht-slide-back' : 'ht-slide';

    return (
        <TransitionGroup
            childFactory={childFactoryCreator({ classNames: HTTransition, timeout: duration })}
        >
            <CSSTransition key={pageKey} timeout={duration} onEntered={handleEntered} onEntering={handleEntering} appear>
                {/* you should wrap CSSTransition child in a div in case it could be null
                see https://github.com/reactjs/react-transition-group/issues/208 */}
                <>{ children }</>
            </CSSTransition>
        </TransitionGroup>
    );
};
